import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';
import {
    Checkbox, Container, FormControlLabel,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import styles from '../../assets/jss/components/ListCustomLayoutSeminarAndLivestream';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CustomTypography from '../../components/Typography/CustomTypography';
import ListCustomLayout from '../../components/ListCustomLayoutSeminarAndLivestream/ListCustomLayoutSeminarAndLivestream';
import dateUtils from '../../utils/dateUtils';
import { SEMINAR_STATUS_TEXT } from '../../common/Constants';
import { platform, PLATFORM } from '../../utils/getPlatform';

const useStyles = makeStyles(styles);

const ListSeminarViewerCustomLayout = ({
    listData, isAuthorized, isWeakAuth, customColor, handleOpenDetail, handleRegisterCheck, customText, registerCheck, eventInfo, locale,
}) => {
    const classes = useStyles({ customColor });
    const intl = useIntl();

    const createListView = () => {
        const viewTotal = [];
        (Object.keys(listData).forEach((key) => {
            (Object.keys(listData[key]).forEach((roomData) => {
                let viewData = [];
                if (listData[key][roomData]) {
                    viewData = listData[key][roomData].map((seminar) => {
                        const utcDateNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Tokyo' }));
                        const yearStart = +seminar.date.split('-')[0];
                        const mouthStart = +seminar.date.split('-')[1];
                        const dayStart = +seminar.date.split('-')[2];
                        const hourStart = +seminar.stime.split(':')[0];
                        const minutesStart = +seminar.stime.split(':')[1];
                        const hourEnd = +seminar.etime.split(':')[0];
                        const minutesEnd = +seminar.etime.split(':')[1];
                        const timeRunningStart = new Date(yearStart, mouthStart - 1, dayStart, hourStart, minutesStart);
                        const timeRunningEnd = new Date(yearStart, mouthStart - 1, dayStart, hourEnd, minutesEnd);
                        const isActiveBeforeStart = utcDateNow <= new Date(timeRunningStart.setDate(timeRunningStart.getDate() - 30));
                        const isActiveAfterEnd = utcDateNow >= new Date(timeRunningEnd.setDate(timeRunningEnd.getDate() + 30));
                        const seminarDisable = isActiveBeforeStart || isActiveAfterEnd;
                        const disableCheckBox = seminar.registered ? { color: '#00000042' } : { color: eventInfo?.settings_colors_viewer?.button_background_color?.common_button };
                        const dataDateTime = {
                            date: seminar.date,
                            stime: seminar.stime,
                            etime: seminar.etime,
                        };
                        return (
                            <>
                                <ListCustomLayout
                                    content={seminar.content}
                                    time={`${seminar.stime}~${seminar.etime}`}
                                    date={dateUtils.formatJa(new Date(seminar.date), locale)}
                                    title={seminar.title}
                                    textStatus={SEMINAR_STATUS_TEXT[locale][seminar.status]}
                                    priceItem={seminar.cost > 0
                                        ? `${intl.formatNumber(seminar.cost)}${intl.formatMessage({ id: 'common.yen' })}`
                                        : intl.formatMessage({ id: 'common.free' })}
                                    speakerName={seminar.speaker}
                                    speakerProfile={locale === 'ja' ? seminar.speaker_profile : ''}
                                    urlImg={seminar.speaker_img}
                                    customColor={customColor}
                                    handleViewDetail={() => handleOpenDetail(seminar.id, dataDateTime, seminar.registered, seminar.is_paused)}
                                    button={(!eventInfo.free_seminar && isAuthorized && isWeakAuth === '') && (
                                        <FormControlLabel
                                            style={{ marginRight: '0px' }}
                                            control={(
                                                <Checkbox
                                                    disabled={seminarDisable}
                                                    checked={(registerCheck[seminar.id] && registerCheck[seminar.id][seminar.id]) || seminar.registered}
                                                    onChange={(e) => handleRegisterCheck(e, seminar.id, seminar.cost, seminar.title)}
                                                    onClick={(e) => e.stopPropagation()}
                                                    style={disableCheckBox}
                                                />
                                            )}
                                            label={(
                                                <CustomTypography
                                                    variant="h6"
                                                    customColor={customColor?.contents_text_color}
                                                    className={!seminarDisable ? classes.textPrice : classes.textPriceDisable}
                                                >
                                                    {customText?.field_name?.application_check || intl.formatMessage({ id: 'livestream.apply' })}
                                                </CustomTypography>
                                            )}
                                        />
                                    )}
                                />
                            </>
                        );
                    });
                }
                viewTotal.push(createTitle(roomData, viewData));
            }));
        }));
        return viewTotal;
    };

    const createTitle = (title, viewData) => (
        <>
            <GridContainer>
                <GridItem>
                    <CustomTypography
                        className={classes.listTitle}
                        variant="h5"
                        bold
                        color="white"
                        customColor={customColor?.list_table?.title_text_color}
                    >
                        {title}
                    </CustomTypography>
                </GridItem>
            </GridContainer>
            <Divider className={classes.dividerUp} />
            {viewData}
        </>
    );
    return (
        <>
            {platform === PLATFORM.OTHER ? (
                <Container>
                    {createListView()}
                </Container>
            ) : createListView()}
        </>
    );
};

ListSeminarViewerCustomLayout.defaultProps = {
    listData: [],
    customColor: {},
    customText: {},
    handleOpenDetail: () => {},
    handleRegisterCheck: () => {},
    isWeakAuth: false || undefined,
    registerCheck: {},
    isAuthorized: {},
    eventInfo: {},
    locale: 'ja',
};

ListSeminarViewerCustomLayout.propTypes = {
    listData: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])),
    customColor: PropTypes.oneOfType([() => null, PropTypes.object]),
    customText: PropTypes.oneOfType([() => null, PropTypes.object]),
    handleOpenDetail: PropTypes.func,
    handleRegisterCheck: PropTypes.func,
    isWeakAuth: PropTypes.oneOfType([() => PropTypes.bool, PropTypes.string]),
    registerCheck: PropTypes.oneOfType([() => null, PropTypes.object]),
    isAuthorized: PropTypes.oneOfType([() => PropTypes.string, PropTypes.bool]),
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
    locale: PropTypes.string,
};

export default ListSeminarViewerCustomLayout;
